import {
  ButtonBase,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add'

import { getDefaultCurrency } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import { RateObject } from '../../types/bulkUpdate'
import InventoryInputItem from './InventoryInputItem'
import useStyles from './styles/InventoryRates.styles'

interface InventoryRatesProps {
  rates: RateObject[]
  setRates: React.Dispatch<React.SetStateAction<RateObject[]>>
  title?: string
}

const InventoryRates: React.FC<InventoryRatesProps> = ({
  rates,
  setRates,
  title
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    <div className={classes.root}>
      <div className={classes.restrictionSelector}>
        <ButtonBase
          className={classes.titleContainer}
          onClick={() =>
            setRates((currentRates) => [
              ...currentRates,
              {
                occupancy: currentRates.length + 1,
                currency: getDefaultCurrency(),
                amount: 0
              }
            ])
          }>
          <AddIcon color="primary" />
          {title}
        </ButtonBase>
        <div
          className={[
            classes.valueContainer,
            classes.restrictionSelectorTitle
          ].join(' ')}>
          <Typography>
            {isSmall ? getTranslate('') : getTranslate('Rate') + ' :'}
          </Typography>
        </div>
      </div>
      {rates.map((rateItem, rateIndex) => (
        <InventoryInputItem
          titleEditable
          label={rateItem.occupancy.toString()}
          onChangeLabel={(labelValue) =>
            setRates((currentRates) => [
              ...currentRates.slice(0, rateIndex),
              {
                ...rateItem,
                occupancy: parseInt(labelValue)
              },
              ...currentRates.slice(rateIndex + 1)
            ])
          }
          value={rateItem.amount.toString()}
          onChange={(value) =>
            setRates((currentRates) => [
              ...currentRates.slice(0, rateIndex),
              {
                ...rateItem,
                amount: value === '' ? 0 : parseFloat(value)
              },
              ...currentRates.slice(rateIndex + 1)
            ])
          }
          showCurrencySelector
          onChangeCurrency={(value) =>
            setRates((currentRates) => [
              ...currentRates.slice(0, rateIndex),
              {
                ...rateItem,
                currency: value
              },
              ...currentRates.slice(rateIndex + 1)
            ])
          }
          deletable
          onDelete={() =>
            setRates((currentRates) => [
              ...currentRates.slice(0, rateIndex),
              ...currentRates.slice(rateIndex + 1)
            ])
          }
        />
      ))}
    </div>
  )
}

export default InventoryRates
